import React from "react";
import styles from "../../styles/About.module.css";
import image from "../../assets/images/aboutimage.png";

const About = () => {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.aboutWrapper}>
        <h1 className={styles.aboutTitle}>About Anjila Khadka</h1>

        <div className={styles.aboutTop}>
          {/* <img src={image} alt="Anjila Khadka" className={styles.aboutImage} /> */}

          <div className={styles.aboutIntro}>
            {/* <p className={styles.aboutText}>
              I am an architect with a deep passion for designing spaces that
              blend functionality, aesthetics, and human experience. My work
              focuses on creating environments that inspire and endure — where
              form meets purpose and beauty meets structure.
            </p> */}
          </div>
        </div>

        <div className={styles.aboutContent}>
          {/* <p className={styles.aboutText}>
            With years of experience in architectural design and project
            management, I've worked on a range of projects — from private
            residences to large-scale urban developments. Every design begins
            with understanding people, place, and purpose.
          </p> */}

          {/* <p className={styles.aboutText}>
            My approach is rooted in sustainability, innovation, and attention
            to detail. I believe architecture shapes lives, and every line drawn
            today can influence how we live tomorrow.
          </p> */}
        </div>
      </div>
    </section>
  );
};

export { About };
